/**
 * Display ALL-CAPS catalog names in title case.
 * Leaves mixed/proper case strings unchanged so intentional casing is preserved.
 * "ENGLEFIELD BY KOHLER … (EA)" → "Englefield By Kohler … (Ea)"
 *
 * @param {string|null|undefined} value
 * @returns {string}
 */
export function toTitleCase (value) {
  const s = String(value == null ? '' : value).trim()
  if (!s) return ''
  // Already has lowercase letters — treat as intentionally cased
  if (/[a-z]/.test(s)) return s
  // No letters at all
  if (!/[A-Za-z]/.test(s)) return s
  return s
    .toLowerCase()
    .replace(/(^|[^A-Za-z0-9]+)([a-z0-9])/g, (_, sep, ch) => sep + ch.toUpperCase())
}

/**
 * Title-case product/material description fields used in the UI and when selecting.
 * @param {Object|null|undefined} item
 * @returns {Object|null|undefined}
 */
export function titleCaseCatalogItem (item) {
  if (!item || typeof item !== 'object') return item
  const next = Object.assign({}, item)
  if (next.description != null) next.description = toTitleCase(next.description)
  if (next.name != null) next.name = toTitleCase(next.name)
  if (next.title != null) next.title = toTitleCase(next.title)
  return next
}
